import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BookEditionPage } from '@/features/product/pages/BookEditionPage';
import { catalogueNameSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/book-editions')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.BOOK_EDITION_VIEW),
  validateSearch: catalogueNameSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Book Edition">
      <Suspense fallback={<PageLoader />}>
        <BookEditionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
